<template>
  <div>
    <search-form
      :fetchData="fetch"
      ref="searchFormRef"
      :handelSearch="handelSearch"
      :handelAdd="handelExport"
      :collection="formCollection"
      :ableSearch="ableSearch"
      :resetWillRequest="true"
      @reset="handelSearch"
      addText="导出"
      :ableAdd="ableAdd"
    ></search-form>
    <a-button 
      v-if="ableMark" 
      type="primary" 
      :disabled="!selectedKeys.length"
      @click="showLabelModal"
      style="margin-bottom: 10px;"
    >标记</a-button>
    <a-modal
      width="900px"
      v-model:open="open"
      :title="pageName"
      :footer="null"
      :destroyOnClose="true"
      :keyboard="false"
      class="action-form-model no-pdModal"
    >
      <action
        :v-if="open"
        @submit="clickOk"
        :isEdit="isEdit"
        :editData="editData"
        :data="tableData"
        :idField="idField"
        :disabled="true"
      ></action>
      <approval_process_content
        :data="approvalProcessData"
      ></approval_process_content>
    </a-modal>
    <a-table
      :columns="columns"
      :row-key="(record) => record.uuid"
      :rowKey="(record) => record['car_application_id']"
      :data-source="tableData"
      :pagination="pagination"
      :loading="loading"
      @change="handleTableChange"
      :scroll="{ x: 1500, y: 500 }"
      :customRow="handleRow"
      :rowClassName="handleRowClassName"
      :row-hover="false"
      :row-selection="rowSelection"
      size="small"
      :bordered="false"
    >
      <template #bodyCell="{ column, record, index }">
        <template v-if="column.key === 'rowIndex'">
          {{ index + 1 }}
        </template>
        <template v-if="column.key === 'visit_area'">
          {{ codeToText(record.visit_area, Enum.areaType.value) }}
        </template>
        <template v-if="column.key === 'visitor_type'">
          {{ codeToText(record.visitor_type, Enum.carVisitType.value) }}
        </template>
        <template v-if="column.key === 'interviewee_depart_id'">
          {{ codeToText(record.interviewee_depart_id, Enum.dept.value) }}
        </template>
        <template v-if="column.key === 'vehicle_type_id'">
          {{ codeToText(record.vehicle_type_id, Enum.carModel.value) }}
        </template>
        <template v-if="column.key === 'visitor_begin_time'">
          {{ record.visitor_begin_time }} 至
          {{ record.visitor_end_time }}
        </template>
        <template v-if="column.key === 'state'">
          {{ codeToText(record.state, Enum.status.value) }}
        </template>
        <template v-if="column.key === 'create_user_id'">
          {{ codeToText(record.create_user_id, Enum.user.value) }}
        </template>
        <template v-if="column.dataInObject">
          {{
            record[column.dataInObject] &&
            record[column.dataInObject][column.dataIndex]
          }}
        </template>
        <template v-if="column.key === 'action'">
          <span>
            <a-button
              @click="showEditModal(record)"
              :loading="loadingRecord === record"
            >
              详情
            </a-button>
            <a-button
              @click="showApprovalProcess(record)"
              :loading="loadingRecord === record[idField] + 'process'"
              v-if="record.state !== 0"
            >
              审批流程
            </a-button>
            <a-button
              @click="showRevokeModal(record)"
              v-if="ableRevoke && (record.state === 1 || record.state === 2)"
              :loading="loadingRecord === record[idField] + 'revoke'"
            >撤销审批</a-button>
            <a-button
              @click="showRejectModal(record)"
              v-if="ableRevoke && record.state === 1"
              :loading="loadingRecord === record[idField] + 'reject'"
              danger
            >驳回</a-button>
<!--            <a-button @click="showRemarkModal(record)">标记原因</a-button>-->

            <a-popconfirm
              v-if="ableReturnSubmit && (record.state === 3 || record.state === 4)"
              title="此预约单将从之前撤销或驳回的审批节点开始继续审批"
              ok-text="确认"
              cancel-text="取消"
              @confirm="returnSubmitRow(record)"
            >
              <a-button>继续审批</a-button>
            </a-popconfirm>
          </span>
        </template>
      </template>
    </a-table>
    <approval_process
      v-model:openModal="approvalProcessOpen"
      :data="approvalProcessData"
    ></approval_process>
    <a-modal v-model:open="revokeModalOpen" title="是否撤销审批？">
      <a-form :model="revokeModalData" ref="revokeModalFormRef" :rules="revokeModalRules">
        <a-form-item label="撤销理由" name="reason">
          <a-textarea v-model:value="revokeModalData.reason" placeholder="请输入撤销理由" />
        </a-form-item>
      </a-form>
      <template #footer>
        <a-button @click="revokeModalOpen = false">取消</a-button>
        <a-button type="primary" @click="revoke">确定</a-button>
      </template>
    </a-modal>
    
    <!-- 标记弹窗 -->
    <a-modal 
      v-model:open="labelModalOpen" 
      title="标记车辆" 
      @ok="handleLabelSubmit"
      :confirmLoading="labelLoading"
    >
      <a-form :model="labelModalData" ref="labelModalFormRef" :label-col="{ span: 4 }" :rules="labelModalRules">
        <a-form-item label="标记颜色" name="color_id">
          <a-select v-model:value="labelModalData.color_id" placeholder="请选择标记类型">
            <a-select-option v-for="item in labelColor" :value="item.value" :key="item.value">{{ item.label }}</a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item label="标记类型" name="label_type_id">
          <a-select v-model:value="labelModalData.label_type_id" placeholder="请选择标记种类">
            <a-select-option v-for="item in labelType" :value="item.value" :key="item.value">{{ item.label }}</a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item label="告警类型" name="alarm_id">
          <a-select v-model:value="labelModalData.alarm_id" placeholder="请选择标记告警">
            <a-select-option v-for="item in labelAlarmType" :value="item.value" :key="item.value">{{ item.label }}</a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item label="标记原因" name="remark">
          <a-textarea 
            v-model:value="labelModalData.remark" 
            placeholder="请输入标记原因" 
            :rows="4"
          />
        </a-form-item>
        <a-form-item label="现场图片" name="photo">
          <img-upload v-model="labelModalData.photo" :number="9" />
        </a-form-item>
      </a-form>
    </a-modal>
    
    <!-- 标记原因弹窗 -->
    <a-modal 
      v-model:open="remarkModalOpen" 
      title="标记原因" 
      width="500px"
      :footer="null"
    >
      <div style="padding: 10px; border: 1px solid #ccc; border-radius: 4px; min-height: 100px;">
        {{ remarkData }}
      </div>
    </a-modal>
    
    <!-- 驳回弹窗 -->
    <a-modal 
      v-model:open="rejectModalOpen" 
      title="驳回申请" 
      width="600px"
      :confirmLoading="rejectLoading"
    >
      <a-form :model="rejectModalData" ref="rejectModalFormRef" :rules="rejectModalRules" >
        <a-form-item label="预约单号">
          <a-input v-model:value="rejectModalData.application_number" :disabled="true" />
        </a-form-item>
        <a-form-item label="车牌号码">
          <a-input v-model:value="rejectModalData.license_plate" :disabled="true" />
        </a-form-item>
        <a-form-item label="来访日期">
          <a-input v-model:value="rejectModalData.visit_date" :disabled="true" />
        </a-form-item>
        <a-form-item label="审批意见" name="remark">
          <a-textarea 
            v-model:value="rejectModalData.remark" 
            placeholder="请输入审批意见" 
            :rows="4"
          />
        </a-form-item>
      </a-form>
      <template #footer>
        <a-button @click="rejectModalOpen = false">取消</a-button>
        <a-button type="primary" danger @click="handleReject">确定驳回</a-button>
      </template>
    </a-modal>
  </div>
</template>
<script setup>
  import { ref, onMounted, toRefs, computed } from 'vue'
  import { useStore } from 'vuex'
  import { useRoute } from 'vue-router'
  import {
    getData,
    getDetail,
    labelVehicle,
    remarkVehicle,
    returnVehicle,
    returnSubmit,
  } from '@/api/car_application/all_car_application_history'
  import { revokeForAllHis } from '@/api/car_application/car_application_history'
  import { approvalProcess, deleteData } from '@/api/car_application/enterprise_application'
  import action from './action'
  import { message } from 'ant-design-vue'
  import { codeToText, constantToOptions } from '@/utils/format'
  import searchForm from '@/components/search_form'
  import approval_process from '@/components/approval_process'
  import approval_process_content from '@/components/approval_process_content'
  import { fileExportPost } from '@/utils/download'
  import imgUpload from '@/components/form/img_upload'
  import { carProcessNodeName } from '@/utils/common'



  //初始化
  const pageName = '园区企业预约申请记录'
  const idField = 'car_application_id' //响应数据的id的字段名
  const store = useStore()
  const route = useRoute()
  const permissionList = computed(() => store.getters['user/permissionList'])
  const Enum = toRefs(store.state.common)

  const ableSearch = computed(() =>
    !!permissionList.value?.find(item => item.code === 'allCarApplyHistory:list')
  )
  const ableRevoke = computed(() =>
    !!permissionList.value?.find(item => item.code === 'carApplyAllHis:revoke')
  )
  const ableMark = computed(() =>
    !!permissionList.value?.find(item => item.code === 'allCarApplyHistory:label')
  )
  const ableAdd = computed(() =>
    !!permissionList.value?.find(item => item.code === 'allCarApplyHistory:export')
  )
  const ableReturnSubmit = computed(() =>
    !!permissionList.value?.find(item => item.code === 'carApplyAllHis:revoke')
  )

  const common = computed(() => store.state.common)
  const labelColor = computed(() => {
    return Object.keys(common.value.labelColor).filter(item => common.value.labelColor[item] !== '全部')
      .map(item => ({
        value: item,
        label: common.value.labelColor[item]
      }))
  })
  const labelType = computed(() => {
    return Object.keys(common.value.labelType).filter(item => common.value.labelType[item] !== '全部')
      .map(item => ({
      value: item,
      label: common.value.labelType[item]
    }))
  })
  const labelAlarmType = computed(() => {
    return Object.keys(common.value.labelAlarmType).filter(item => common.value.labelAlarmType[item] !== '全部')
      .map(item => ({
      value: item,
      label: common.value.labelAlarmType[item]
    }))
  })

  //1、搜索框
  const formCollection = [
    {
      type: 'input',
      field: 'application_id',
      label: '预约单号',
    },
    {
      type: 'input',
      field: 'license_plate',
      label: '车牌号码',
    },
    {
      type: 'input',
      field: 'trailer_license',
      label: '挂车号牌',
    },
    {
      type: 'input',
      field: 'applicant_name',
      label: '申请人姓名',
    },
    {
      type: 'input',
      field: 'applicant_phone',
      label: '申请人联系号码',
    },
    {
      type: 'input',
      field: 'applicant_idcard',
      label: '申请人证件号码',
    },
    {
      type: 'input',
      field: 'visitor_company',
      label: '来访单位',
    },
    {
      type: 'input',
      field: 'interviewee_name',
      label: '被访人员姓名',
    },
    {
      type: 'input',
      field: 'interviewee_phone',
      label: '被访人联系电话',
    },
    {
      type: 'select',
      field: 'interviewee_depart_id',
      storeOptions: 'dept',
      label: '被访机构',
      width: '190px',
      'allowClear': true,
    },
    {
      type: 'select',
      field: 'visit_type_id',
      storeOptions: 'areaType',
      // defaultValue: 1,
      label: '申请园区',
      width: '130px',
      'allowClear': true,
    },
    {
      type: 'select',
      field: 'vehicle_type_id',
      label: '车型',
      storeOptions: 'carModel',
      width: '190px',
      'allowClear': true,
    },
    {
      type: 'select',
      field: 'process_node_name',
      options: constantToOptions(carProcessNodeName),
      defaultValue: '',
      label: '审核节点',
      width: '130px',
      allowClear: true,
    },
    {
      type: 'select',
      field: 'status',
      storeOptions: 'status',
      defaultValue: -1,
      label: '审核状态',
      width: '130px',
    },
    {
      type: 'select',
      storeOptions: 'carVisitType',
      field: 'application_type',
      label: '申请类型',
      width: '130px',
      allowClear: true,
    },
    {
      type: 'select',
      storeOptions: 'documentType',
      field: 'idcard_type',
      label: '访客类型',
      width: '130px',
      allowClear: true,
    },
    {
      type: 'dateRange',
      startField: 'visitor_begin_time',
      endField: 'visitor_end_time',
      // defaultStart: dayjs().subtract(365, 'day').format('YYYY-MM-DD'),
      // defaultEnd: dayjs().add(30, 'day').format('YYYY-MM-DD'),
      label: '有效时间范围',
    },
    {
      type: 'dateRange',
      startField: 'create_date_start',
      endField: 'create_date_end',
      label: '创建时间',
    },
  ]
  const searchFormRef = ref()
  function handelSearch() {
    pagination.value.current = 1
    fetch()
    const params = {
      ...searchFormRef.value.formState,
    }
    store.commit('search/setAllCarAppliceHistory', params)
  }

  //2、表格
  const columns = [
    {
      title: '序号',
      dataIndex: 'rowIndex',
      key: 'rowIndex',
      align: 'center',
      width: 50,
      fixed: 'left',
    },
    {
      title: '预约单号',
      key: 'application_number',
      dataIndex: 'application_number',
      align: 'left',
      width: 200,
    },
    {
      title: '审批状态',
      // dataIndex: 'state',
      // key: 'state',
      dataIndex: 'approval_status',
      key: 'approval_status',
      align: 'left',
      width: 130,
    },
    {
      title: '车牌号码',
      dataIndex: 'license_plate',
      key: 'license_plate',
      align: 'left',
      width: 100,
    },
    {
      title: '车型',
      dataIndex: 'vehicle_type_id',
      key: 'vehicle_type_id',
      align: 'left',
      width: 180,
    },
    {
      title: '申请人',
      dataIndex: 'applicant_name',
      key: 'applicant_name',
      align: 'left',
      width: 100,
    },
    {
      title: '申请人证件号码',
      key: 'applicant_idcard',
      dataIndex: 'applicant_idcard',
      align: 'left',
      width: 180,
    },
    {
      title: '申请人联系号码',
      key: 'applicant_phone',
      dataIndex: 'applicant_phone',
      align: 'left',
      width: 130,
    },
    {
      title: '申请园区',
      dataIndex: 'visit_area',
      key: 'visit_area',
      align: 'left',
      width: 90,
    },
    {
      title: '申请类型',
      dataIndex: 'visitor_type',
      key: 'visitor_type',
      align: 'left',
      width: 90,
    },
    {
      title: '来访单位',
      dataIndex: 'visitor_company',
      key: 'visitor_company',
      align: 'left',
      width: 180
    },
    {
      title: '来访事由',
      dataIndex: 'visitor_content',
      key: 'visitor_content',
      align: 'left',
      width: 180
    },
    {
      title: '入园时间',
      dataIndex: 'visitor_begin_time',
      key: 'visitor_begin_time',
      align: 'left',
      width: 210,
    },
    {
      title: '被访人员',
      dataIndex: 'interviewee_name',
      key: 'interviewee_name',
      align: 'left',
      width: 90,
    },
    {
      title: '被访人联系电话',
      dataIndex: 'interviewee_phone',
      key: 'interviewee_phone',
      align: 'left',
      width: 130,
    },
    /*{
      title: '被访机构',
      dataIndex: 'interviewee_depart_id',
      key: 'interviewee_depart_id',
      align: 'left',
      width: 180
    },*/
    {
      title: '被访机构',
      dataIndex: 'name',
      key: 'name',
      dataInObject: 'intervieweeDepart',
      align: 'left',
      width: 180,
    },
    {
      title: '被标记原因',
      dataIndex: 'label_remark',
      key: 'label_remark',
      align: 'left',
      width: 180,
    },
    {
      title: '黑名单',
      dataIndex: 'in_black_list',
      key: 'in_black_list',
      align: 'left',
      width: 70,
    },
    {
      title: '撤销理由',
      dataIndex: 'revoke_reason',
      key: 'revoke_reason',
      align: 'left',
      width: 180,
    },
    {
      title: '创建人',
      dataIndex: 'create_user_id',
      key: 'create_user_id',
      align: 'left',
      width: 80,
    },
    {
      title: '修改人',
      dataIndex: 'update_user_name',
      key: 'update_user_name',
      align: 'left',
      width: 80,
    },
    /*{
      title: '创建时间',
      dataIndex: 'create_time',
      key: 'create_time',
      align: 'left',
      width: 170,
    },
    {
      title: '更新时间',
      dataIndex: 'update_time',
      key: 'update_time',
      align: 'left',
      width: 170,
    },*/
    {
      title: '提交审核时间',
      dataIndex: 'submit_time',
      key: 'submit_time',
      align: 'left',
      width: 170,
    },
    {
      // title: '最后审核时间',
      title: '审核时间',
      dataIndex: 'approve_time',
      key: 'approve_time',
      align: 'left',
      width: 170,
    },
    {
      title: '操作',
      dataIndex: 'action',
      key: 'action',
      align: 'left',
      fixed: 'right',
      width: '190px',
    },
  ]

  const tableData = ref([])
  const loading = ref(false)
  const loadingRecord = ref()
  const pagination = ref({
    current: 1,
    pageSize: 10,
    showLessItems: true,
    showQuickJumper: true,
    showSizeChanger: true,
    showTotal: (total, range) => {
      return `共 ${total} 条`
    },
  })

  const selectedKeys = ref([])
  const rowSelection = computed(() => ({
    onChange: (selectedRowKeys, selectedRows) => {
      selectedKeys.value = selectedRows.map(item => item.car_application_id)
    },
    selectedRowKeys: selectedKeys.value,
  }))

  function handleTableChange(page) {
    pagination.value = { ...pagination.value, ...page }
    fetch()
  }

  const handleRow = (record) => {
    return {
      ondblclick: (event) => {
        event.stopPropagation()
        showEditModal(record)
      },
    }
  }

  function fetch() {
    //获取表单值
    const formState = searchFormRef.value?.formState

    loading.value = true
    getData({
      size: pagination.value.pageSize,
      pn: pagination.value.current,
      ...formState,
    }).then(({ data }) => {
      loading.value = false
      tableData.value = data.list
      pagination.value.total = data.total
      // 保存数据到store
      store.commit('search/setAllCarAppliceHistoryTableData', data.list)
      store.commit('search/setAllCarAppliceHistoryPagination', pagination.value)
    })
  }

  // 从store获取缓存的搜索参数、表格数据和分页信息
  const cachedSearchParams = computed(
    () => store.state.search.searchAllCarAppliceHistory
  )
  const cachedTableData = computed(
    () => store.state.search.allCarAppliceHistoryTableData
  )
  const cachedPagination = computed(
    () => store.state.search.allCarAppliceHistoryPagination
  )
  onMounted(() => {
    // 恢复搜索参数
    for (const key in cachedSearchParams.value) {
      searchFormRef.value.formState[key] = cachedSearchParams.value[key]
    }
    
    // 如果是从标签页点击跳转过来的，从store恢复表格数据和分页信息
    if (route.query?.fromTabClick) {
      if (cachedTableData.value) {
        tableData.value = cachedTableData.value
      }
      if (cachedPagination.value) {
        pagination.value = cachedPagination.value
      }
      return
    }
    
    // 否则执行查询
    fetch()
  })

  //3、编辑、添加
  const open = ref(false)
  const isEdit = ref(false)
  const editData = ref(null)

  // const showAddModal = () => {
  //   editData.value = null
  //   isEdit.value = false
  //   open.value = true
  // }
  const showEditModal = async (data) => {
    loadingRecord.value = data
    const detail = await fetchDetail(data[idField])
    loadingRecord.value = null
    if (detail) {
      editData.value = detail
      isEdit.value = true
      open.value = true
      approvalProcessData.value = []
      // 获取审批流程
      if (data.state !== 0 && data.state !== 4) {
        await getApprovalProcess(data[idField])
      }
    }
  }
  async function fetchDetail(id) {
    const res = await getDetail({ id })
    if (res.success) {
      return res.data
    } else {
      message.warn('获取详情失败')
    }
  }

  function clickOk() {
    fetch()
    handleOk()
    clearEditData()
  }

  const handleOk = () => {
    open.value = false
  }
  const clearEditData = () => {
    editData.value = null
  }

  //4、审批流程
  const approvalProcessOpen = ref(false)
  const approvalProcessData = ref()
  async function getApprovalProcess(id) {
    const res = await approvalProcess({ id })
    approvalProcessData.value = res.data
  }
  async function showApprovalProcess(record) {
    loadingRecord.value = record[idField] + 'process'
    await getApprovalProcess(record[idField])
    approvalProcessOpen.value = true
    loadingRecord.value = null
  }
  async function revoke() {
    await revokeModalFormRef.value.validate()
    const { id, reason } = revokeModalData.value
    loadingRecord.value = id + 'revoke'
    try {
      const res = await revokeForAllHis({ id, reason })
      if (res.success) {
        message.success(res.msg)
        revokeModalOpen.value = false
      }
      fetch()
    } finally {
      loadingRecord.value = null
    }
  }

  const revokeModalFormRef = ref()
  const revokeModalRules = {
    reason: [
      { required: true, message: '请输入撤销理由', trigger: 'blur' }
    ]
  }
  const revokeModalOpen = ref(false)
  const revokeModalData = ref({
    reason: '',
    id: ''
  })
  function showRevokeModal(record) {
    revokeModalData.value = {
      reason: '',
      id: record[idField]
    }
    revokeModalOpen.value = true
  }

  function handleRowClassName(record) {
    // 标记类型为标记类型，行字体改成红色
    if(record.label_status === 1 && record.label_type_id == 1) {
      return 'row-red';
    }
    // 标记类型为提醒类型，行字体改成黄色
    if(record.label_status === 1 && record.label_type_id == 2) {
      return 'row-yellow';
    }
    return ''
  }

  // 标记相关
  const labelModalOpen = ref(false)
  const labelLoading = ref(false)
  const labelModalFormRef = ref()
  const labelModalData = ref({
    car_application_ids: [],
    color_id: 2,
    label_type_id: 1,
    alarm_id: 3,
    remark: '',
    photo: [],
  })
  const labelModalRules = {
    remark: [
      { required: true, message: '请输入标记原因', trigger: 'blur' }
    ]
  }

  function showLabelModal() {
    if (selectedKeys.value.length === 0) {
      message.warning('请先选择要标记的车辆')
      return
    }
    labelModalData.value = {
      car_application_ids: selectedKeys.value,
      color_id: '2',
      label_type_id: '1',
      alarm_id: '3',
      remark: '',
      photo: [],
    }
    labelModalOpen.value = true
  }

  async function handleLabelSubmit() {
    try {
      await labelModalFormRef.value.validate()
      labelLoading.value = true
      
      const res = await labelVehicle({
        ...labelModalData.value,
        car_application_ids: labelModalData.value.car_application_ids.join(',')
      })
      
      if (res.success) {
        message.success('标记成功')
        labelModalOpen.value = false
        selectedKeys.value = []
        fetch()
      } else {
        message.error(res.message || '标记失败')
      }
    } finally {
      labelLoading.value = false
    }
  }

  // 标记原因相关
  const remarkModalOpen = ref(false)
  const remarkLoading = ref(false)
  const remarkData = ref(null)
  
  // 驳回相关
  const rejectModalOpen = ref(false)
  const rejectModalFormRef = ref()
  const rejectLoading = ref(false)
  const rejectModalData = ref({
    carApplicationId: '',
    application_number: '',
    license_plate: '',
    visit_date: '',
    remark: ''
  })
  const rejectModalRules = {
    remark: [
      { required: true, message: '请输入审批意见', trigger: 'blur' }
    ]
  }

  async function showRemarkModal(record) { 
    remarkModalOpen.value = true
    remarkLoading.value = true
    remarkData.value = null
    
    try {
      const res = await remarkVehicle({ licensePlate: record.license_plate })
      
      if (res.success) {
        remarkData.value = res.data
      } else {
        message.error(res.msg || '获取标记原因失败')
      }
    } catch (error) {
      console.error('获取标记原因失败:', error)
      message.error('获取标记原因失败')
    } finally {
      remarkLoading.value = false
    }
  }
  
  function showRejectModal(record) {
    rejectModalData.value = {
      carApplicationId: record[idField],
      application_number: record.application_number,
      license_plate: record.license_plate,
      visit_date: `${record.visitor_begin_time} 至 ${record.visitor_end_time}`,
      remark: ''
    }
    rejectModalOpen.value = true
  }
  
  async function handleReject() {
    try {
      await rejectModalFormRef.value.validate()
      rejectLoading.value = true
      loadingRecord.value = rejectModalData.value.carApplicationId + 'reject'
      
      const res = await returnVehicle({
        carApplicationId: rejectModalData.value.carApplicationId,
        remark: rejectModalData.value.remark
      })
      
      if (res.success) {
        message.success('驳回成功')
        rejectModalOpen.value = false
        fetch()
      } else {
        message.error(res.message || '驳回失败')
      }
    } catch (error) {
      console.error('驳回失败:', error)
      message.error('驳回失败，请重试')
    } finally {
      rejectLoading.value = false
      loadingRecord.value = null
    }
  }

  async function returnSubmitRow(data) {
    const res = await returnSubmit({ carApplicationId: data[idField] })
    if (res.success) {
      message.success('操作成功')
      fetch()
    } else {
      message.warn(res.message)
    }
  }

  //导出
  const exporting = ref(false)
  async function handelExport() {
    exporting.value = true
    const formState = searchFormRef.value?.formState
    fileExportPost({
      onFinally: () => (exporting.value = false),
      name: `车辆预约信息导出.xlsx`,
      url: `/api/carApplications/all/history/export`,
      data: formState,
    })
  }
</script>

<style lang="less" scoped>
::v-deep .ant-table .row-red {
  color: #EB0013;
  font-weight: 700;
}
::v-deep .ant-table .row-yellow {
  color: #dfdc26;
  font-weight: 700;
}
</style>